import { useEffect, useRef } from "react";

export default function VideoItem({ item }) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    video.play().catch(() => { });
                } else {
                    video.pause();
                }
            },
            {
                threshold: 0.6,
            }
        );

        if (video) observer.observe(video);

        return () => {
            if (video) observer.unobserve(video);
        };
    }, []);

    return (
        <video
            ref={videoRef}
            src={item.video}
            className="w-100 videos2"
            muted
            loop
            playsInline
            preload="none"
        />
    );
}